module.exports = __webpack_public_path__ + "static/media/philippines-flag-square-medium.cec5e13d.png";